import { render } from "./ProjectSummaryCompleted.vue?vue&type=template&id=17bbf2bc"
import script from "./ProjectSummaryCompleted.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCompleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__